module.exports = __webpack_public_path__ + "static/media/Building.5cd8de7b.png";